// Adding required wrapping responsive div to WYSIWYG tables

class ContentTables {
  constructor() {
    this.contentTables = document.querySelectorAll('.content table');
    this.init();
  }

  init() {
    this.contentTables.forEach((contentTable) => {
      // Create wrapping div
      const wrappingDiv = document.createElement('DIV');
      wrappingDiv.classList.add('table-responsive');
      // Insert wrapping div before exisiting table
      contentTable.parentNode.insertBefore(wrappingDiv, contentTable);
      // Move table into wrapping div
      wrappingDiv.appendChild(contentTable);
    });
  }
}

document.addEventListener('DOMContentLoaded', () => new ContentTables());
